<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/cNtin1/tc-custom/9781488057472.jpg?1725275644460" alt="This image is the cover for the book Before the Storm"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Before the Storm
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times </i>bestseller, a “graceful . . . engrossing” novel about a mother struggling to protect her disabled son after he is accused of a crime (<i>Publishers Weekly</i>).</b><br/><br/>Fifteen-year-old Andy Lockwood is special. Others notice the way he blurts out anything that comes into his mind, how he cannot foresee consequences, that he’s more child than teenager. But his mother sees a boy with a heart as open and wide as the ocean.<br/><br/>Laurel Lockwood lost her son once through neglect. She’s spent the rest of her life determined to make up for her mistakes, and she’s succeeded in becoming a committed, protective parent—maybe even overprotective. Still, she loosens her grip just enough to let Andy attend a local church social—a decision that terrifies her when the church is consumed by fire. But Andy survives . . . and remarkably, saves other children from the flames. Laurel watches as Andy basks in the role of unlikely hero and the world finally sees her Andy, the sweet boy she knows as well as her own heart.<br/><br/>But when the suspicion of arson is cast upon Andy, Laurel must ask herself how well she really knows her son . . . and how far she’ll go to keep her promise to protect him forever.<br/><br/><b>Praise for <i>The Silent Sister </i>by Diane Chamberlin:</b><br/><br/>“Powerful and thrilling This tautly paced and emotionally driven novel will engross Chamberlain’s many fans as well as those who read Sandra Brown and Carla Buckley.” ?<i>Booklist</i><br/><br/>“Hard to put down.” ?<i>Better Homes and Gardens</i><br/><br/><i>“</i>A compulsively readable melodrama.” ?<i>Kirkus Reviews</i><br/><br/>“A page-turner to the very end. A must for all mystery lovers and those who like reading about family struggles.” ?<i>Library Journal</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Diane Chamberlain
      </h2>
      
      <p class="authorDescription body article">Diane Chamberlain is the bestselling author of twenty novels, including The Midwife's Confession and The Secret Life of CeeCee Wilkes. Diane lives in North Carolina and is currently at work on her next novel. Visit her Web site at www.dianechamberlain.com and her blog at www.dianechamberlain.com/blog and her Facebook page at www.facebook.com/Diane.Chamberlain.Readers.Page.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises Limited
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?64ed126a